import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  DepartmentUpdate,
} from "../../redux/services/DepartmentService/deparment.Services";

import {
  successToast,
  errorToast,
} from "../../Utils/toast";

import {
  closeModal,
} from "../../redux/features/modalSlice";

function EditDepartment({ data  }) {
  const dispatch = useDispatch();
const { refreshData } = useSelector(
  (state) => state.modal
);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    status: true,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        status:
          data.status === 1 ||
          data.status === true,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "status"
          ? value === "Active"
          : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const payload = {
        id: data?.id,
        name: formData.name,
        status: formData.status ? 1 : 0,
      };

      const res = await DepartmentUpdate(payload);
    if (res?.success) {
  successToast(res?.message);

  refreshData?.(); // table refresh

  dispatch(closeModal());
}


    } catch (err) {
      console.log(err);

      errorToast(
        err?.message ||
          "Error updating Department"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form
        onSubmit={handleSubmit}
        className="row"
      >

        <div className="col-md-12">
          <label>Department Name</label>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter role name"
          />
        </div>

        <div className="col-md-12">
          <label>Status</label>

          <select
            name="status"
            value={
              formData.status
                ? "Active"
                : "Inactive"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>

        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="add-btn"
          >
            {isLoading
              ? "Updating..."
              : "Update Department"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default EditDepartment;